import ResumeView from "./ResumeView";
import { useEffect, useState } from "react";
import { useRef } from "react";
import toast from "react-hot-toast";
import FooterLayout from "../../Components/FooterLayout";
import groupIcon from "../../Assets/Icons/Group1.png";
import Select from "../../Components/CommonCommponents/select/Select";
import { useForm } from "react-hook-form";
import Input from "../../Components/CommonCommponents/Input";
import AuthService from "../../Service.js/authService";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Button } from "antd";
import DatePicker from "../../Components/CommonCommponents/DatePicker";
import CandodateService from "../../Service.js/CandidateService";
import { dateConverter } from "../../Components/Utilities/util";
import dayjs from "dayjs";
import TextArea from "../../Components/CommonCommponents/TextArea";
import TextEdit from "../../Components/CommonCommponents/TextEditor";
import RadioGroup from "../../Components/CommonCommponents/RadioGroup";
import OtpVerification from "./OtpVerification";
import CountryCodeInput from "../../Components/CommonCommponents/CountyCodeInput";
const ProfileConfrmation = (props) => {
  const [isCountryLayout, setCountryLayout] = useState(false);
  const [phoneCode, setPhonecode] = useState();
  const [loading, setLoading] = useState(false);
  const {
    register,
    control,
    setError,
    setValue,
    reset,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });
  const handelInputChange = (onChange, e) => {
    onChange(e);
    if (e.target.value !== "") {
      var test = Number(e.target.value);
      var test1 = Number.isInteger(test);
      if (test1) {
        setCountryLayout(true);
        setPhonecode("+91");
      } else {
        setCountryLayout(false);
        setPhonecode("");
      }
    } else {
      setCountryLayout(false);
      setPhonecode("");
    }
  };

  const handelChangePhone = (e) => {
    var value = `+${e}`;
    setPhonecode(value);
  };
  const resumeDetails = props?.extractedDetails[0];

  const details = () => {
    setValue("mobile_number", resumeDetails?.national_number);
    setValue("email", resumeDetails?.email);
    setValue(
      "country_code",
      resumeDetails?.country_code ? resumeDetails?.country_code : "",
    );
  };
  useEffect(() => {
    details();
  }, [resumeDetails]);

  // const onSubmit = async (data) => {
  //   setLoading(true);
  //   const json = {
  //     email: data.email,
  //     mobile_number: data.mobile_number
  //       ? data.country_code
  //         ? `+${data.country_code}${data.mobile_number}`
  //         : `+91${data.mobile_number}`
  //       : "",
  //   };
  //   const formData = new FormData();

  //   Object.entries(json).forEach(([key, value]) => {
  //     formData.append(key, value);
  //   });

  //   formData.append("resumes", props.selectedFile);

  //   await AuthService.signupConfirmation(formData)
  //     .then(
  //       (response) => {
  //         console.log("response", response.data.data);
  //         localStorage.setItem(
  //           "candidate_id",
  //           JSON.stringify(response.data.data.user),
  //         );

  //         toast.success("Sucessfully Verifiyed");
  //         props.setIsConfirm(false);
  //         props.setIsVerifyOtp(true);
  //         setLoading(false);
  //         //naviate("/profileConfirmation");
  //       },
  //       (error) => {
  //         const errorsObj = error.response.data.error_info;
  //         Object.keys(errorsObj).forEach((field) => {
  //           const messages = errorsObj[field];
  //           setError(field, {
  //             type: "server",
  //             message: messages.join(". "),
  //           });
  //         });
  //         setLoading(false);
  //       },
  //     )
  //     .catch((error) => {
  //       console.log("error", error);
  //       toast.error("Failed To Register");
  //       setLoading(false);
  //     });
  // };
  const onSubmit = async (data) => {
    setLoading(true);
    const json = {
      email: data.email,
      mobile_number: data.mobile_number
        ? data.country_code
          ? `+${data.country_code}${data.mobile_number}`
          : `+91${data.mobile_number}`
        : "",
    };
 
    const formData = new FormData();
 
    Object.entries(json).forEach(([key, value]) => {
      formData.append(key, value);
    });
 
    formData.append("resumes", props.selectedFile);
 
    // const allowLocation = window.confirm(
    //   "Allow location access to improve job matching?",
    // );
 
    // if navigator.geolocation) {
    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
 
      formData.append("latitude", position.coords.latitude);
      formData.append("longitude", position.coords.longitude);
    } catch (error) {
      console.log("User denied location permission");
    }
    // }
 
    await AuthService.signupConfirmation(formData)
      .then(
        (response) => {
          localStorage.setItem(
            "candidate_id",
            JSON.stringify(response.data.data.user),
          );
 
          toast.success("Successfully Verified");
          props.setIsConfirm(false);
          props.setIsVerifyOtp(true);
          setLoading(false);
        },
        (error) => {
          const errorsObj = error.response.data.error_info;
          Object.keys(errorsObj).forEach((field) => {
            const messages = errorsObj[field];
            setError(field, {
              type: "server",
              message: messages.join(". "),
            });
          });
          setLoading(false);
        },
      )
      .catch((error) => {
        console.log("error", error);
        toast.error("Failed To Register");
        setLoading(false);
      });
  };
  return (
    //     <div className="w-full h-screen">
    //   <div className="pageContent w-full scrollbar-hide">
    //     <div className="w-full flex flex-col md:flex-row items-center mt-10 md:mt-24 md:ml-28 px-4 sm:px-8">
    //       <div className="flex rounded-xl bg-white mb-10 md:mb-20 w-full max-w-2xl sm:max-w-3xl md:max-w-4xl ">
    //         <div className="w-full">
    //           <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
    //             <div className="mt-10 md:mt-20 md:ml-18 px-4 sm:px-4  ">
    //               <p className="text-3xl sm:text-4xl md:text-5xl font-semibold mb-10 sm:mb-14 md:mb-16 text-center md:text-left">
    //                 Sign Up
    //               </p>

    //               <label className="block mb-4 font-semibold text-base sm:text-lg pb-2">
    //                 Email ID or Mobile Number
    //               </label>

    //               <div className="w-full md:w-[590px] pb-3">
    //                 <div className="w-full pt-3">
    //                   <Input
    //                     name="email"
    //                     control={control}
    //                     placeholder="Enter your Email"
    //                     rules={{
    //                       required: "This field is required",
    //                     }}
    //                     className="h-12 p-4 text-base w-full"
    //                   />
    //                 </div>

    //                 <div className="w-full">
    //                   <CountryCodeInput
    //                     name="mobile_number"
    //                     country_code_name="country_code"
    //                     country_code_value={watch("country_code")}
    //                     value={watch("mobile_number")}
    //                     setValue={setValue}
    //                     required={true}
    //                     control={control}
    //                     rules={{
    //                       required: "This field is required",
    //                     }}
    //                   />
    //                 </div>
    //               </div>

    //               <div className="flex justify-center md:justify-start mt-4">
    //                 <button
    //                   className="bg-[#0071DC] text-white font-bold px-10 h-[46px] rounded-lg w-full sm:w-auto"
    //                   type="submit"
    //                 >
    //                   Confirm
    //                 </button>
    //               </div>
    //             </div>
    //           </form>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>

    <div className="w-[100%] md-w-[90%] md:w-[75%] flex flex-col gap-10">
      {/* <div className="w-[100%] md-w-[90%] md:w-[75%] flex flex-col  md-0 md:mt-28 lg:mt-28 "> */}

      {/* <div className=" md:px-14 pb-10 "> */}
      <form className="px-6 md:px-14 " onSubmit={handleSubmit(onSubmit)}>
        <div className="">
          <p className="text-3xl md:text-5xl font-semibold mb-10 md:mb-20 mt-6 md:mt-0">
            Sign Up
          </p>

          <label className="block font-semibold text-lg">Email</label>

          <div className="w-full max-w-lg md:max-w-xl lg:max-w-2xl ">
            {/* Email Input */}
            <div className="w-full mb-4">
              <Input
                name="email"
                control={control}
                placeholder="Enter your Email"
                rules={{
                  required: "This field is required",
                }}
                className="h-12 w-full border border-gray-300 rounded-md  focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-200"
              />
            </div>

            {/* Mobile Input */}
            <div className="w-full">
              <CountryCodeInput
                name="mobile_number"
                country_code_name="country_code"
                country_code_value={watch("country_code")}
                value={watch("mobile_number")}
                setValue={setValue}
                required={true}
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
              />
            </div>
          </div>

          <div className="pt-4">
            <button
              className="bg-[#1C4980] text-white w-full h-[42px] rounded-full flex items-center justify-center"
              type="submit"
              disabled={loading}
            >
              {loading ? <span className="loader mr-2"></span> : null}
              {loading ? "Processing..." : "Confirm"}
            </button>{" "}
          </div>
        </div>
      </form>
      {/* </div> */}
      {/* </div> */}
    </div>
  );
};
export default ProfileConfrmation;

{
  /* <Input
                      name="mobile_number"
                      label="Mobile number"
                      placeholder="Enter your Mobile number"
                      control={control}
                      rules={{
                        required: "This field is required",
                      }}
                      className="h-12"
                    /> */
}
{
  /* <div className="w-full">
                      <div style={{ display: "flex" }}>
                        {isCountryLayout && (
                          <span
                            style={{
                              width: "10%",
                              paddingLeft: "5px",
                              paddingTop: "5px",
                              marginTop: "36px",
                              paddingRight: "45px",
                            }}
                          >
                            <PhoneInput
                              country="In"
                              value="91"
                              inputStyle={{
                                height: "35px",
                                width: "2%",
                                paddingLeft: "0px",
                              }}
                              onChange={(e) => handelChangePhone(e)}
                            />
                          </span>
                        )}
                        <div className="w-">
                          <Input
                            name="mobile_number"
                            label="Mobile number"
                            placeholder="Enter your Mobile number"
                            control={control}
                            rules={{
                              required: "This field is required",
                              // pattern: {
                              //   value: /^[0-9]+$/,
                              //   message: "only numeric values are allowed",
                              // },
                            }}
                            onChange={handelInputChange}
                          />
                        </div>
                      </div>
                    </div> */
}
